export const SHOP_PORTABLE_INNER_BLOCK_TYPES = [
    "addToCartButton",
    "avatars",
    "code",
    "donationButton",
    "map",
    "supportedPaymentButton",
] as const;

export type ShopPortableInnerBlockType = typeof SHOP_PORTABLE_INNER_BLOCK_TYPES[number];

export function isShopPortableInnerBlockType(value: string): value is ShopPortableInnerBlockType {
    return (SHOP_PORTABLE_INNER_BLOCK_TYPES as readonly string[]).includes(value);
}

export function shopPortableAspectRatio(value: unknown): string {
    if (value === "standard") return "4 / 3";
    if (value === "square") return "1 / 1";

    return "16 / 9";
}

export type ShopPortableProgressLabelPosition = "above" | "after" | "below" | "hide" | "inside";

export function shopPortableProgressLabelPosition(
    value: unknown,
): ShopPortableProgressLabelPosition {
    if (value === "above") return "above";
    if (value === "after") return "after";
    if (value === "below" || value === "outside") return "below";
    if (value === "hide" || value === "none") return "hide";

    return "inside";
}

export type ShopPaymentBrand = "applepay" | "card" | "googlepay" | "mastercard" | "visa";

export function shopPaymentBrand(value: string): ShopPaymentBrand {
    const normalized = value.toLowerCase().replace(/[^a-z0-9]+/g, "");

    if (normalized.includes("mastercard")) return "mastercard";
    if (normalized.includes("apple")) return "applepay";
    if (normalized.includes("google")) return "googlepay";
    if (normalized.includes("visa")) return "visa";

    return "card";
}

export function shopPaymentBrandGlyph(brand: ShopPaymentBrand): string {
    if (brand === "mastercard") return "●●";
    if (brand === "applepay") return "●";
    if (brand === "googlepay") return "G";
    if (brand === "visa") return "V";

    return "•";
}

export function shopAvatarInitials(value: string): string {
    const words = value.trim().split(/\s+/).filter(Boolean);

    return words.slice(0, 2).map((word) => word[0]?.toUpperCase() ?? "").join("") || "?";
}
